<div class="form-group">
    <por-base-select label="Select" [options]="options" (modelChange)="handleSelect($event)" [model]="selectedLanguage" porAddFeature featureName="language-selector"></por-base-select>
</div>
